module.exports = __webpack_public_path__ + "img/joaquim.3c692cba.jpg";